import { Dayjs } from "dayjs";

export enum transactionTypes {
  EINNAHME = "Einnahme",
  AUSGABE = "Ausgabe",
  CANCEL = "Stornierung",
  REFUND = "Rückerstattung"
}

export enum paymentStatus {
  PAID = "Bezahlt",
  PARTIAL = "Teilweise bezahlt",
  NOT_PAID = "Nicht bezahlt",
  GKV_COPAYMENT_REQUESTED =  "GKV Zuzahlung angefordert"
}

export enum transactionMethods {
  CASH = "CASH",
  LASTSCHRIFT = "LASTSCHRIFT",
  EC = "EC",
  VERSICHERUNG = "VERSICHERUNG",
  INTERNAL = "INTERNAL", // Ausgabe auf Geschäftskosten (keine Zahlung)
}

export enum recnungTransactionMethods {
  RECHNUNG = "RECHNUNG",
  BANK_TRANSFER = "BANKTRANSFER",
}

export type AllTransactionMethods = transactionMethods | recnungTransactionMethods;


export interface DateRange {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
}

export type DateRangesByMethod = {
  [methods in AllTransactionMethods]?: DateRange;
};

export enum TarifGroupIds {
  BG = "BG",
  BLANKO = "Blanko",
  GKV = "GKV",
  POST = "Post",
  POST_BLANKO = "PostBlanko",
  PRIVATE = "Privat",
}